import React from "react";
import Divider from "@material-ui/core/Divider";

import styles from "./styles.module.scss";

export default function DividerComponent() { return <Divider className={styles.divider} /> }
